var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

$(document).on("click", ".handle-help", function (e) {
    e.preventDefault();

    var href = $(document).find("#modal-help-href").data("save");
    var code = $(this).data('help');

    $.nette.ajax({
        url: href + '&code=' + code,
        type: 'GET',
        off: {
            snippets: true
        }
    }).done(function () {
        $('#helpModal').modal('toggle');
    });
});